import { useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import type { GoalTask } from '../../api/types';

interface Props {
  /** The part that was just ticked off as bought; null hides the prompt. */
  part: GoalTask | null;
  onDecline: () => void;
  onAccept: (part: GoalTask) => void;
}

/**
 * Asked right after a Buy task is completed: a bought part usually still has
 * to be fitted, so offer to add the matching Do task.
 */
export function InstallJobPrompt({ part, onDecline, onAccept }: Props) {
  const { t } = useTranslation();
  // Keep naming the part while the dialog fades out after `part` is cleared.
  const lastPart = useRef<GoalTask | null>(null);
  if (part) lastPart.current = part;

  return (
    <Dialog open={part !== null} onClose={onDecline} fullWidth maxWidth="xs">
      <DialogTitle>{t('garageCar.goals.installPrompt.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('garageCar.goals.installPrompt.body', { part: lastPart.current?.title ?? '' })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDecline}>{t('garageCar.goals.installPrompt.decline')}</Button>
        <Button variant="contained" onClick={() => part && onAccept(part)}>
          {t('garageCar.goals.installPrompt.accept')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
